/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './app.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../$$_gendir/node_modules/angular2-notifications/src/simple-notifications/components/simple-notifications.component.ngfactory';
import * as i3 from 'angular2-notifications/src/simple-notifications/components/simple-notifications.component';
import * as i4 from 'angular2-notifications/src/simple-notifications/services/notifications.service';
import * as i5 from '@angular/router';
import * as i6 from '../../app/app.component';
const styles_AppComponent:any[] = [i0.styles];
export const RenderType_AppComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,styles:styles_AppComponent,
    data:{}});
export function View_AppComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'simple-notifications',
      ([] as any[]),(null as any),(null as any),(null as any),i2.View_SimpleNotificationsComponent_0,
      i2.RenderType_SimpleNotificationsComponent)),i1.ɵdid(245760,(null as any),0,
      i3.SimpleNotificationsComponent,[i4.NotificationsService],{options:[0,'options']},
      (null as any)),(_l()(),i1.ɵted((null as any),['\n'])),(_l()(),i1.ɵeld(16777216,
      (null as any),(null as any),2,'router-outlet',([] as any[]),(null as any),(null as any),
      (null as any),(null as any),(null as any))),i1.ɵdid(212992,(null as any),0,i5.RouterOutlet,
      [i5.ChildrenOutletContexts,i1.ViewContainerRef,i1.ComponentFactoryResolver,[8,
          (null as any)],i1.ChangeDetectorRef],(null as any),(null as any)),(_l()(),
      i1.ɵted((null as any),['\n'])),(_l()(),i1.ɵted((null as any),['\n']))],(_ck,
      _v) => {
    var _co:i6.AppComponent = _v.component;
    const currVal_0:any = _co.options;
    _ck(_v,1,0,currVal_0);
    _ck(_v,4,0);
  },(null as any));
}
export function View_AppComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'app-root',([] as any[]),
      (null as any),(null as any),(null as any),View_AppComponent_0,RenderType_AppComponent)),
      i1.ɵdid(49152,(null as any),0,i6.AppComponent,([] as any[]),(null as any),(null as any))],
      (null as any),(null as any));
}
export const AppComponentNgFactory:i1.ComponentFactory<i6.AppComponent> = i1.ɵccf('app-root',
    i6.AppComponent,View_AppComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovTXlEZW1vL0FuZ3VsYXIyLURlbW8vQW5ndWxhci1hZG1pbi9zcmMvYXBwL2FwcC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRTovTXlEZW1vL0FuZ3VsYXIyLURlbW8vQW5ndWxhci1hZG1pbi9zcmMvYXBwL2FwcC5jb21wb25lbnQudHMiLCJuZzovLy9FOi9NeURlbW8vQW5ndWxhcjItRGVtby9Bbmd1bGFyLWFkbWluL3NyYy9hcHAvYXBwLmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRTovTXlEZW1vL0FuZ3VsYXIyLURlbW8vQW5ndWxhci1hZG1pbi9zcmMvYXBwL2FwcC5jb21wb25lbnQudHMuQXBwQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPHNpbXBsZS1ub3RpZmljYXRpb25zIFtvcHRpb25zXT1cIm9wdGlvbnNcIj48L3NpbXBsZS1ub3RpZmljYXRpb25zPlxuPHJvdXRlci1vdXRsZXQ+XG48L3JvdXRlci1vdXRsZXQ+XG4iLCI8YXBwLXJvb3Q+PC9hcHAtcm9vdD4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7Z0RBQUEsVUFBQTtzQ0FBQTtNQUFBLGVBQWlFLHVDQUNqRTtNQUFBO01BQUEsbURBQUE7TUFBQTtVQUFBLGtFQUFlO2FBQUEsd0JBQ0M7OztJQUZNO0lBQXRCLFdBQXNCLFNBQXRCO0lBQ0E7Ozs7b0JDREE7TUFBQTthQUFBOzs7OyJ9



// WEBPACK FOOTER //
// E:/MyDemo/Angular2-Demo/Angular-admin/src/$$_gendir/app/app.component.ngfactory.ts